import React, { Component } from 'react';
import AdminSalesForceAuditTable from './AdminSalesForceAuditTable';

export class AdminSalesForceAuditBMSFContent extends Component {
  render() {

    return (
      <AdminSalesForceAuditTable titleTableList={this.props.titleTableList} tableList={this.props.tableList} />
    )
  }
}

export default AdminSalesForceAuditBMSFContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminSalesForceAudit/AdminSalesForceAuditBMSFContent.js